import { inject, TransferState } from "@angular/core";
import { API_URL, TURNSTILE_KEY } from "../token";
import { API_URL_STATE, TURNSTILE_KEY_STATE } from "./state-key";

export const provideClientConfig = () => {
    return [
            {
                provide: API_URL,
                useFactory: () => {
                    const state = inject(TransferState);

                    if (state.hasKey(API_URL_STATE)) {
                    return state.get(API_URL_STATE, '');
                    }

                    return '';
                }
            },
            {
                provide: TURNSTILE_KEY,
                useFactory: () => {
                    const state = inject(TransferState);

                    if (state.hasKey(TURNSTILE_KEY_STATE)) {
                        return state.get(TURNSTILE_KEY_STATE, '');
                    }

                    return '';
                }
            },
        ];
    };
